import { useNewTranslations } from '@/common/translations';
import type { Tuple5 } from '@/common/types';
import { Section } from '@/ui/components';

import { ApiWidgetType, StatsTypes } from '../../../constants';
import { TwoJerseysWithStats } from '../../../components';
import { useStatsData } from '../../../hooks';

const Overview = () => {
  const translate = useNewTranslations();
  const { teams, widget } = useStatsData({
    widgetType: StatsTypes.OVERVIEW,
  });

  const sectionName = translate('PreMatchStats.Overview');
  const statsLabels: Tuple5<string> = [
    translate('PreMatchStats.TableColumnPlayedShort'),
    translate('PreMatchStats.TableColumnVictoryShort'),
    translate('PreMatchStats.TableColumnDrawShort'),
    translate('PreMatchStats.TableColumnLossShort'),
    translate('PreMatchStats.TableColumnPointsShort'),
  ];

  if (!widget || widget.type !== ApiWidgetType.OVERVIEW || !widget?.data) {
    return null;
  }

  const { home, away } = widget.data;

  if (!home || !away) {
    return null;
  }

  return (
    <Section name={sectionName}>
      <TwoJerseysWithStats
        homeConfig={{
          jerseySrc: teams.home.jersey,
          size: 82,
          withOverlay: true,
          teamNumber: home.no,
          leagueName: home.leagueName,
          statsLabels,
          statsValues: [home.playedMatches, home.wins, home.draws, home.losses, home.points],
        }}
        awayConfig={{
          jerseySrc: teams.away.jersey,
          size: 82,
          withOverlay: true,
          teamNumber: away.no,
          leagueName: away.leagueName,
          statsLabels,
          statsValues: [away.playedMatches, away.wins, away.draws, away.losses, away.points],
        }}
      />
    </Section>
  );
};

export default Overview;
